/* tslint:disable */
/* eslint-disable */
export enum QualityCategory {
    Basic = 'BASIC',
    Standard = 'STANDARD',
    Premium = 'PREMIUM'
}
